/**
 * Chromium Scroll Position Fix
 * Evita que el navegador restaure una posición de scroll antigua al cargar
 * o al navegar con Turbo. NO bloquea el scroll del usuario.
 *
 * Nota: la versión anterior sobreescribía window.scrollTo / scrollBy durante
 * 2 segundos y forzaba el scroll al tope repetidamente. Eso hacía que el
 * scroll "rebotara" al inicio y diera la sensación de estar roto. Se eliminó.
 */

(function () {
    'use strict';

    // Detectar navegadores basados en Chromium.
    var isChromium = /Chrome|Chromium|Edge/.test(navigator.userAgent) &&
        !/Firefox|Safari(?!.*Chrome)/.test(navigator.userAgent);

    if (!isChromium) return;

    // 1. Desactivar la restauración automática de scroll del navegador.
    if ('scrollRestoration' in history) {
        history.scrollRestoration = 'manual';
    }

    // 2. Empezar arriba en la carga inicial (una sola vez, sin pelear con el
    //    usuario después).
    function scrollTop() {
        window.scrollTo(0, 0);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', scrollTop, { once: true });
    } else {
        scrollTop();
    }

    // 3. Al navegar con Turbo, ir arriba en la nueva vista. Turbo ya lo hace
    //    en visitas completas; esto cubre el render del frame.
    document.addEventListener('turbo:load', scrollTop);

    // 4. Mantener el modo manual tras volver atrás/adelante en el historial.
    window.addEventListener('beforeunload', function () {
        if ('scrollRestoration' in history) {
            history.scrollRestoration = 'manual';
        }
    });
})();
